import React, { useState, useEffect, useRef } from 'react';

import { IconHelp } from '@tabler/icons-react';

import { SupportModalV1 } from './SupportModalV1';

export const DraggableHelpButton = () => {
  const [position, setPosition] = useState({ x: 20, y: 20 });
  const [dragging, setDragging] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const buttonRef = useRef<HTMLDivElement>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDragStart = (e: React.MouseEvent) => {
    setDragging(true);
    e.preventDefault();
  };

  const handleDrag = (e: MouseEvent) => {
    if (dragging) {
      setPosition({
        x: window.innerWidth - e.clientX - 40,
        y: window.innerHeight - e.clientY - 40,
      });
    }
  };

  const handleDragEnd = () => {
    setDragging(false);
  };

  const handleButtonClick = () => {
    if (!dragging) {
      if (isExpanded) {
        setIsModalOpen(true);
      } else {
        setIsExpanded(true);
      }
    }
  };

  const handleOutsideClick = (e: MouseEvent) => {
    if (buttonRef.current && !buttonRef.current.contains(e.target as Node)) {
      setIsExpanded(false);
    }
  };

  useEffect(() => {
    if (dragging) {
      document.addEventListener('mousemove', handleDrag);
      document.addEventListener('mouseup', handleDragEnd);
    } else {
      document.removeEventListener('mousemove', handleDrag);
      document.removeEventListener('mouseup', handleDragEnd);
    }
    return () => {
      document.removeEventListener('mousemove', handleDrag);
      document.removeEventListener('mouseup', handleDragEnd);
    };
  }, [dragging]);

  useEffect(() => {
    if (isExpanded) {
      document.addEventListener('mousedown', handleOutsideClick);
    } else {
      document.removeEventListener('mousedown', handleOutsideClick);
    }
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [isExpanded]);

  return (
    <div>
      <div
        ref={buttonRef}
        className="fixed z-[9999] cursor-grab"
        style={{
          right: position.x,
          bottom: position.y,
        }}
        onMouseDown={handleDragStart}
      >
        <button
          // Expanded, the visible "Get Help" names it; an aria-label then would hide that text (WCAG 2.5.3).
          aria-label={isExpanded ? undefined : 'Help & support'}
          className={`flex items-center justify-center rounded-full bg-brand-800 text-white shadow-lg transition-all duration-300 hover:bg-brand-900 focus:outline-none focus:ring-4 focus:ring-purple-500`}
          onClick={handleButtonClick}
        >
          {isExpanded && (
            <span className="text-m ml-4 font-medium leading-none text-white md:text-base">
              Get Help
            </span>
          )}
          <div className="rounded-full p-2 transition-colors duration-300">
            <IconHelp
              stroke={2}
              className={`${isExpanded ? 'text-white' : 'text-brand-400'} ${
                isExpanded ? 'h-8 w-8' : 'h-6 w-6 md:h-8 md:w-8'
              }`}
            />
          </div>
        </button>
      </div>
      {isModalOpen && <SupportModalV1 onClose={() => setIsModalOpen(false)} />}
    </div>
  );
};
